let errorLogs = [];

/**
 * Log an error and collect the message for periodical sending to log collector.
 * Example: logCollector('main.js:24', 'Example exception', e);
 * @param {*} location javascript filename:line number
 * @param {*} message error message
 * @param {*} error error object
 */
const logCollector = (location, message, error) => {
  console.error(`${location}:${message}`, error);
  errorLogs.push({ location, error, message });
};

setInterval(() => {
  if (errorLogs.length > 0) {
    // TODO: Send log entries to server or log collector
    console.log('TODO: Send log entries to server or log collector', errorLogs);
    errorLogs = [];
  }
}, 5000);

export default logCollector;
